<div class="sp-loader" [class.sp-loader--small]="small" [ngStyle]="styleRules">
  <div class="sp-spinner">
    <div class="sp-container">
      <div class="sp-hex0"></div>
      <div class="sp-hex120"></div>
      <div class="sp-hex240"></div>
    </div>
  </div>
</div>
